import FeedbackIcon from "@mui/icons-material/Feedback";
import { makeStyles } from "@mui/styles";
import { SnackbarProvider } from "notistack";
import React from "react";

const useStyles = makeStyles(() => {
	return {
		info: {
			fontSize: `16px !important`,
			color: `black !important`,
			backgroundColor: `#FFC233 !important`,
			marginBottom: `3rem !important`,
			display: "flex",
			justifyContent: "center",
		},
	};
});
type childrenType = {
	children: JSX.Element | React.ReactNode;
};
export default function NotiSanckProvider({ children }: childrenType) {
	const classes = useStyles();
	return (
		<SnackbarProvider
			maxSnack={5}
			preventDuplicate
			autoHideDuration={1800}
			anchorOrigin={{
				vertical: "bottom",
				horizontal: "center",
			}}
			iconVariant={{
				info: <FeedbackIcon sx={{ marginRight: "0.5rem" }} />,
			}}
			classes={{
				variantInfo: classes.info,
			}}
		>
			{children}
		</SnackbarProvider>
	);
}
